module.exports = __webpack_public_path__ + "static/media/Monetize manufacturing capacity.b9a2f62f.svg";